import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.125 21.751v1.5m15.75-1.5v1.5M9.75 15.001v6.75m7.5-6.75v-8.25m-2.121-2.122a3 3 0 0 1 4.242 0m-6.364-2.121a6 6 0 0 1 8.486 0m-1.618 19.243a3.375 3.375 0 0 0 0-6.75H4.125a3.375 3.375 0 0 0 0 6.75z"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M18.75 18.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m-4.5.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1)
  ]));
}
const computerDeviceNetworkWifiRouter = { render };
export {
  computerDeviceNetworkWifiRouter as default,
  render
};
//# sourceMappingURL=computer-device-network-wifi-router.svg.js.map
